import api from './api';

const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

export const getExpenseDashboardSummary = (params) => api.get('/v1/expense-dashboard/summary', { params: clean(params) });
export const getCategoryTrends = (params) => api.get('/v1/expense-dashboard/category-trends', { params: clean(params) });
export const getRecentTransactions = (params) => api.get('/v1/expense-dashboard/recent-transactions', { params: clean(params) });
export const getEntryHeatmap = (params) => api.get('/v1/expense-dashboard/entry-heatmap', { params: clean(params) });
export const getTopSpenders = (params) => api.get('/v1/expense-dashboard/top-spenders', { params: clean(params) });
export const getDepartmentCategory = (params) => api.get('/v1/expense-dashboard/department-category', { params: clean(params) });
export const getLocationDistribution = (params) => api.get('/v1/expense-dashboard/location-distribution', { params: clean(params) });
export const getExpenseApprovalPipeline = (params) => api.get('/v1/expense-dashboard/approval-pipeline', { params: clean(params) });
export const getBudgetUsage = (params) => api.get('/v1/expense-dashboard/budget-usage', { params: clean(params) });
export const getExpenseRiskSignals = (params) => api.get('/v1/expense-dashboard/risk-signals', { params: clean(params) });
export const getProjectDashboard = (params) => api.get('/v1/expense-dashboard/projects', { params: clean(params) });

// Bütçe CRUD
export const getExpenseBudgets = (params) => api.get('/v1/expense-budgets', { params: clean(params) });
export const createExpenseBudget = (data) => api.post('/v1/expense-budgets', data);
export const deleteExpenseBudget = (id) => api.delete(`/v1/expense-budgets/${id}`);
